// extracted by mini-css-extract-plugin
export default {"back":"back_back__MSNF4"};